import classnames from 'classnames';
import videojs from 'video.js';

import QualityLevelMenuItem, { MenuItemOptions } from './QualityLevelMenuItem';

const MenuButton = videojs.getComponent('MenuButton');

export type { MenuItemOptions };

class QualityLevelMenuButton extends MenuButton {
  menuItemsOptions: MenuItemOptions[] = [];
  items: QualityLevelMenuItem[] = [];

  buildCSSClass() {
    return classnames(super.buildCSSClass(), 'vjs-quality-levels-menu-button');
  }

  buildWrapperCSSClass() {
    return classnames(
      super.buildWrapperCSSClass(),
      'vjs-quality-levels-menu-button-wrapper'
    );
  }

  resetItemsSelectedState() {
    this.items.forEach((item) => item.selected(false));
  }

  updateItems(itemsOptions: MenuItemOptions[]) {
    this.menuItemsOptions = itemsOptions || [];
    this.update();
  }

  createItems() {
    const items = (this.menuItemsOptions || []).map((options) => {
      return new QualityLevelMenuItem(this.player_, options, {
        menuButton: this,
      });
    });

    return items;
  }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
QualityLevelMenuButton.prototype.controlText_ = 'qualityLevels';

videojs.registerComponent('QualityLevelMenuButton', QualityLevelMenuButton);

export default QualityLevelMenuButton;
